import { render, staticRenderFns } from "./Movimentacao.vue?vue&type=template&id=5271e81b&scoped=true"
import script from "./Movimentacao.vue?vue&type=script&lang=js"
export * from "./Movimentacao.vue?vue&type=script&lang=js"
import style0 from "./Movimentacao.vue?vue&type=style&index=0&id=5271e81b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5271e81b",
  null
  
)

export default component.exports